module.exports = __webpack_public_path__ + "img/azur_unboundtoken.2b1671f.png";